<template>
  <div class="w-full h-full text-center relative" @click="handlerClick">
    <div class="absolute top-0 left-0 right-0 w-full h-full">
      <div class="font-24 c-171A1D-56 mt-45 mb-9"
        ><span v-show="+restStatus === 0">当天不考勤</span>
        <div v-show="+restStatus !== 0"
          >正常{{ IN_OUT_TYPE[inOutType]
          }}<span class="p-0-4 c-171A1D-24">/</span>全部<i
            v-show="!isHeadmaster"
            class="iconfont font-24 ml-4 c-171A1D-40"
            >&#xe66b;</i
          ></div
        ></div
      >
      <p class="font-60 ff-ding-condensed-bold"
        >{{ detail[INTERFACE_TYPE[inOutType]] || 0
        }}<span class="p-0-8 c-171A1D-24">/</span
        >{{ detail.totalMemberCount || 0 }}</p
      >
    </div>
    <svg
      v-if="needUpdate"
      :viewBox="
        `0 0 ${2 * radius + srtokeWidth + 2} ${radius + srtokeWidth + 20}`
      "
    >
      <defs v-show="detail[INTERFACE_TYPE[inOutType]] > 0">
        <linearGradient id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#006AFE" />
          <stop offset="100%" stop-color="#006AFE" />
        </linearGradient>
      </defs>
      <path
        :d="
          `M ${srtokeWidth / 2} ${radius +
            srtokeWidth / 2} a ${radius} ${radius} 0 1 1 ${radius * 2} 0`
        "
        :stroke-width="srtokeWidth"
        :stroke="emptyColor"
        fill="none"
        stroke-linecap="round"
      ></path>
      <path
        :d="
          `M ${srtokeWidth / 2} ${radius +
            srtokeWidth / 2} a ${radius} ${radius} 0 1 1 ${radius * 2} 0`
        "
        :stroke-width="srtokeWidth"
        stroke="url(#linear)"
        fill="none"
        stroke-linecap="round"
        :stroke-dasharray="strokeDasharray"
        :stroke-dashoffset="strokeDashoffset"
      >
        <animate
          attributeName="stroke-dashoffset"
          :dur="`${durTime}ms`"
          fill="freeze"
          :from="strokeDasharray"
          :to="strokeDashoffset"
        ></animate>
      </path>
    </svg>
  </div>
</template>
<script>
import { IN_OUT_TYPE, INTERFACE_TYPE } from '@/utils/constUtils'
export default {
  name: 'commonHalfProgress',
  components: {},
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Number,
      default: 0
    },
    isHeadmaster: {
      type: Boolean,
      default: false
    },
    restStatus: {
      type: Number,
      default: 1
    },
    detail: {
      type: Object,
      default: () => {
        return {
          totalMemberCount: 0,
          normalCheckOutCount: 0,
          normalCheckInCount: 0
        }
      }
    }
  },
  data() {
    return {
      IN_OUT_TYPE: IN_OUT_TYPE,
      INTERFACE_TYPE: INTERFACE_TYPE,
      defaultDurTime: 1000, // 进度条完结时间
      defaultEmptyColor: 'rgba(17, 31, 44, 0.28)', // 默认底色
      defaultSrtokeWidth: 2, // 进度线宽度
      defaultRadius: 44,
      inOutType: null,
      needUpdate: true
    }
  },
  computed: {
    durTime() {
      return this.options
        ? this.options.durTime || this.defaultDurTime
        : this.defaultDurTime
    },
    radius() {
      return this.options
        ? this.options.radius || this.defaultRadius
        : this.defaultRadius
    },
    emptyColor() {
      return this.options
        ? this.options.emptyColor || this.defaultEmptyColor
        : this.defaultEmptyColor
    },
    srtokeWidth() {
      return this.options
        ? this.options.srtokeWidth || this.defaultSrtokeWidth
        : this.defaultSrtokeWidth
    },
    strokeDasharray() {
      return 3.1415926 * this.radius
    },
    strokeDashoffset() {
      return this.strokeDasharray - this.strokeDasharray * this.value
    }
  },
  watch: {
    '$store.getters.inOutType'(v) {
      this.inOutType = v
    },
    value(v) {
      this.needUpdate = false
      this.$nextTick(() => {
        this.needUpdate = true
      })
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      this.inOutType = this.$store.getters.inOutType
    },
    handlerClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>
